import React, { Component, Fragment } from "react";

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Fragment>
        <button
          id="btnSpinner"
          className="btn btn-link d-none"
          data-toggle="modal"
          data-target="#spinnerModal"
          data-backdrop="static"
          data-keyboard="false"
        ></button>

        <div
          className="modal fade"
          id="spinnerModal"
          tabIndex="-1"
          aria-labelledby="spinnerModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ background: "transparent", border: "none" }}
            >
              <div
                className="modal-body text-center"
                style={{ background: "transparent" }}
              >
                <i
                  className="fa fa-spinner fa-spin fa-4x fa-fw"
                  aria-hidden="true"
                  style={{ color: "#ffffff" }}
                ></i>
              </div>
              <div className="modal-footer" style={{ borderTop: "0" }}>
                <button
                  id="btnCloseSpinner"
                  type="button"
                  className="btn btn-danger d-none"
                  data-dismiss="modal"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Loading;
